import { Link } from "react-router-dom";

const essentials = [
  { label: "Police Station", icon: "ri-police-car-line", to: "/directory?q=Police" },
  { label: "Fire & Rescue", icon: "ri-fire-line", to: "/directory?q=Fire" },
  { label: "Hospital", icon: "ri-hospital-line", to: "/category/healthcare" },
  { label: "Ambulance", icon: "ri-truck-line", to: "/directory?q=Ambulance" },
  { label: "Diagnostic Lab", icon: "ri-test-tube-line", to: "/directory?q=Diagnostic" },
  { label: "Blood Bank", icon: "ri-heart-pulse-line", to: "/directory?q=Blood%20Bank" },
  { label: "Pharmacy", icon: "ri-capsule-line", to: "/directory?q=Pharmacy" },
  { label: "Nursing Home", icon: "ri-home-heart-line", to: "/directory?q=Nursing%20Home" },
];

const helplines = [
  { number: "112", label: "All Emergency", icon: "ri-alarm-warning-line" },
  { number: "108", label: "Ambulance", icon: "ri-truck-line" },
  { number: "101", label: "Fire & Rescue", icon: "ri-fire-line" },
  { number: "100", label: "Police", icon: "ri-police-car-line" },
];

export default function EmergencyPanel() {
  return (
    <aside className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50/95 p-4 backdrop-blur md:p-5">
      <div className="flex items-start gap-3">
        <span className="flex h-10 w-10 flex-none items-center justify-center rounded-md bg-red-600 text-background-50">
          <i className="ri-alarm-warning-line text-lg"></i>
        </span>
        <div className="min-w-0 flex-1">
          <h2 className="font-heading text-sm font-bold leading-tight text-foreground-950">Emergency &amp; Essential</h2>
          <p className="mt-0.5 text-[11px] leading-snug text-foreground-500">Time-critical services, one tap away</p>
        </div>
        <span className="flex-none rounded-md border border-red-200 bg-red-50 px-2 py-1 text-[11px] font-bold text-red-600">
          24×7
        </span>
      </div>

      <div className="mt-4 grid grid-cols-2 gap-2">
        {essentials.map((e) => (
          <Link
            key={e.label}
            to={e.to}
            title={`${e.label} near you`}
            className="group flex items-center gap-2 rounded-md border border-background-200 bg-background-50 px-2.5 py-2 transition-colors hover:border-red-300 hover:bg-red-50 cursor-pointer"
          >
            <span className="flex h-7 w-7 flex-none items-center justify-center rounded border border-red-100 bg-red-50 text-red-600 transition-colors group-hover:bg-red-100">
              <i className={`${e.icon} text-sm`}></i>
            </span>
            <span className="truncate text-xs font-semibold text-foreground-800">{e.label}</span>
          </Link>
        ))}
      </div>

      <div className="mt-5 flex items-center gap-2 border-t border-background-200 pt-4">
        <span className="flex h-4 w-4 items-center justify-center text-red-600">
          <i className="ri-phone-fill text-xs"></i>
        </span>
        <p className="text-[11px] font-bold uppercase tracking-[0.12em] text-red-600">Emergency helplines</p>
      </div>
      <div className="mt-2.5 grid grid-cols-2 gap-2">
        {helplines.map((h) => (
          <a
            key={h.number}
            href={`tel:${h.number}`}
            title={`${h.label} — ${h.number}`}
            className="group flex items-center gap-2 rounded-md border border-red-200 bg-red-50 px-2.5 py-2 transition-colors hover:bg-red-100 cursor-pointer"
          >
            <span className="flex h-7 w-7 flex-none items-center justify-center rounded bg-red-600 text-background-50">
              <i className={`${h.icon} text-sm`}></i>
            </span>
            <span className="min-w-0">
              <span className="block font-heading text-sm font-extrabold leading-none text-red-700">{h.number}</span>
              <span className="mt-0.5 block truncate text-[10px] leading-none text-red-500">{h.label}</span>
            </span>
          </a>
        ))}
      </div>

      <Link
        to="/emergency-services"
        className="mt-5 inline-flex h-10 w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 text-sm font-semibold text-foreground-950 transition-colors hover:bg-primary-600 cursor-pointer"
      >
        <i className="ri-phone-line text-sm"></i>
        View all emergency services
      </Link>
    </aside>
  );
}